import { z } from "zod";

// Skema untuk satu periode perbandingan
const ComparePeriodSchema = z.object({
    start: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Invalid date format (YYYY-MM-DD)"),
    end: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Invalid date format (YYYY-MM-DD)"),
});

// Skema filter utama untuk V4
export const GrowthReportFilterSchemaV4 = z.object({
    property_id: z.string().min(1, "Property selection is required"),
    base_on: z.enum(["stay_date", "created_reservation"]),
    compare: z.array(ComparePeriodSchema).min(2, "At least two periods are required for comparison"),
});

export type GrowthReportFilterTypeV4 = z.infer<typeof GrowthReportFilterSchemaV4>;